import HttpService from '../baseHttp'
// 列表页
export const HttpGetSkuSalesList = (data = {}, config) => HttpService.get('/api/v1/ProductTarget/findByPage', { params: data })
// 查看单条
export const HttpGetDetail = (data = {}, config) => HttpService.get('/api/v1/ProductTarget/getById?', { params: data })
// 新增、编辑
export const HttpSaveDetail = (data = {}, config) => HttpService.post('/api/v1/ProductTarget/save', data, { ...config, headers: { "Content-Type": "application/json" } })
// 删除
export const HttpBatchDelete = (data = {}, config) => HttpService.get('/api/v1/ProductTarget/delete', { params: data })


